import React, { Component } from 'react';
import {  Button, InputGroup,FormControl,Table,Container } from 'react-bootstrap';
import axios from 'axios';
import {  Loading } from '../../helpers';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css'

class ViewCheckWeight extends Component {

    constructor(props) {
        super(props);
        this.state = { 
            file: null,
            jobID : '',
            licenseID : '',
            jobIDNow : '',
            licenseIDNow : '',
            dataArr : [],
            isLoading : false,
            arrImage : []
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.uploadToFirebase = this.uploadToFirebase.bind(this);
    }


    handleChange(event) {
        const file = event.target.files[0]
        this.setState({
            ...this.state,
            file : file
         })
         
    }
    handleInput(e){
        this.setState({
            ...this.state,
            [e.target.id] : e.target.value
        })
    }
    uploadToFirebase() {
        this.setState({
            ...this.state,
            isLoading : true,
        })
        axios.post( 
            'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
            {
                'action': 'searchImage',
                'data': {
                    jobID : this.state.jobID,
                    licenseID : this.state.licenseID,
                },
            } 
        ).then((res)=>{
            if(res.data){
                let arrImage = []
                Object.values(res.data).map((temp)=>{
                    arrImage.push({
                        original : temp['url'],
                        thumbnail : temp['url'],
                    })
                })
                this.setState({
                    ...this.state,
                    licenseIDNow : this.state.licenseID,
                    jobIDNow : this.state.jobID,
                    isLoading : false,
                    arrImage : arrImage
                },()=>{
                    let img1 = document.getElementsByClassName('image-gallery-image')[0]
                })
            }else{
                this.setState({
                    ...this.state,
                    isLoading : false,
                },()=>{
                    alert('ไม่พบหมายเลขที่ค้นหา')
                })
            }
        })
    }

    render() {
        return (
            <Container style={{width:'100%',alignContent:'center',textAlign:'center',fontSize:'22px'}}>
                <div style={{marginTop:'3%'}}>
                <a href='http://178.128.220.206'>กลับหน้าหลัก</a>
                <h1>ค้นหารูปภาพ CheckWeight</h1>

                <InputGroup onChange={this.handleInput}  className="mb-3">
                    <FormControl
                    value={this.state.jobID}
                    id='jobID'  
                    placeholder="กรุณากรอกเลข Order No จากใบ Checkweight"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    />
                </InputGroup>
                <InputGroup onChange={this.handleInput}  className="mb-3">
                    <FormControl
                    value={this.state.licenseID}
                    id='licenseID'  
                    placeholder="กรุณากรอกเลข license No จากใบ Checkweight"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    />
                </InputGroup>
        <Button onClick={this.uploadToFirebase}>ค้นหา</Button> <p> Order No : {this.state.jobIDNow}  license No : {this.state.licenseIDNow}</p>
                <br></br>
                <br></br>
                {(()=>{
                    if(this.state.arrImage.length > 0){
                        return ( <ImageGallery showIndex={true} lazyLoad={true} items={this.state.arrImage} />)
                    }
                })()}

                {(()=>{
                    if(this.state.isLoading){
                    return(<Loading title={'กำลังค้นหา'}/>)
                    }else{
                        return(<div></div>)
                    }
                })()}
            </div>
            </Container>
        ); 
    }
}

export default ViewCheckWeight;

